import { useEffect, useRef } from 'react';
import { useUIStore } from './useUIStore';

export const StoragePersistenceInit = () => {
  const setShowPersistenceWarning = useUIStore((s) => s.setShowPersistenceWarning);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const run = async () => {
      // Guard: Storage API requires HTTPS / secure context (Pitfall 5)
      if (!navigator.storage?.persist) return;

      const ua = navigator.userAgent;
      // SamsungBrowser pre-v17 includes "Safari" but omits "Chrome" in its UA,
      // causing a false positive. Exclude it explicitly alongside Chrome variants.
      const isSafari = /Safari/i.test(ua) && !/Chrome|CriOS|FxiOS|SamsungBrowser/i.test(ua);
      const isIOS = /iPhone|iPad|iPod/i.test(ua);

      try {
        await navigator.storage.persist();
        const persisted = await navigator.storage.persisted();
        console.info('[storage] persisted:', persisted);

        if (!persisted && (isSafari || isIOS)) {
          setShowPersistenceWarning(true);
        }
      } catch (e) {
        console.error('[storage] persist check failed', e);
      }
    };

    run();
  }, [setShowPersistenceWarning]);

  return null;
};
